/* kb.js — constructor del dip kit: 6 huecos, drawer de tonos (orden/filtro/vista), ATC kit + 6 tonos → drawer del tema */
(function () {
  function init(root) {
    if (root.__kb) return; root.__kb = true;
    var MAX = 6, picks = [];
    var drawer = root.querySelector('.kb-drawer');
    var grid = root.querySelector('.kb-grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.kb-card'));
    var slots = root.querySelectorAll('.kb-slot');
    var addBtn = root.querySelector('[data-kb-add]');
    var nEl = root.querySelector('[data-kb-n]');
    var pickedEl = root.querySelector('.kb-picked');
    var sticky = root.querySelector('.kb-sticky');
    var fams = window.KB_SHADES || {};

    // mueve drawer y barra fija al body (evita contextos de transform/overflow del buy box)
    document.body.appendChild(drawer); document.body.appendChild(sticky);

    // chips de familia (solo las que existen)
    var bar = drawer.querySelector('[data-kb-filters]');
    (window.KB_FAMILIES || []).forEach(function (f) {
      var has = cards.some(function (c) { return (fams[c.dataset.name] || []).indexOf(f) > -1; });
      if (!has) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'kb-chip'; b.dataset.fam = f; b.textContent = f;
      bar.appendChild(b);
    });

    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.documentElement.classList.add('kb-lock'); }
    function close() { drawer.classList.remove('is-open'); document.documentElement.classList.remove('kb-lock'); setTimeout(function () { drawer.hidden = true; }, 250); }

    function render() {
      slots.forEach(function (s, i) {
        var p = picks[i], img = s.querySelector('.kb-slot__img');
        s.classList.toggle('is-filled', !!p);
        s.title = p ? p.name + ' (tap to remove)' : 'Add a shade';
        img.innerHTML = '';
        if (p) {
          var src = p.card.querySelector('.kb-card__media--nail img');
          if (src) { var im = document.createElement('img'); im.src = src.currentSrc || src.src; im.alt = p.name; img.appendChild(im); }
          else { img.textContent = p.name.split(' ').map(function (w) { return w[0]; }).join('').slice(0, 2).toUpperCase(); }
        }
      });
      cards.forEach(function (c) {
        var n = picks.filter(function (p) { return p.id === c.dataset.id; }).length;
        c.classList.toggle('is-picked', n > 0);
        c.querySelector('.kb-card__count').textContent = n ? '×' + n : '';
      });
      var k = picks.length;
      nEl.textContent = k;
      addBtn.disabled = k < MAX;
      addBtn.firstChild.nodeValue = k < MAX ? 'Choose your colors (' : 'Add kit to cart (';
      pickedEl.textContent = k ? picks.map(function (p) { return p.name; }).join(' · ') : '';
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        if (picks.length >= MAX) { c.classList.add('kb-shake'); setTimeout(function () { c.classList.remove('kb-shake'); }, 400); return; }
        picks.push({ id: c.dataset.id, name: c.dataset.name, card: c }); render();
      });
    });
    slots.forEach(function (s, i) {
      s.addEventListener('click', function () { if (picks[i]) { picks.splice(i, 1); render(); } else { open(); } });
    });
    root.querySelectorAll('[data-kb-open]').forEach(function (b) { b.addEventListener('click', open); });
    sticky.querySelector('[data-kb-open]').addEventListener('click', open);
    drawer.querySelectorAll('[data-kb-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

    drawer.querySelector('[data-kb-sort]').addEventListener('change', function (e) {
      var v = e.target.value;
      cards.slice().sort(function (a, b) {
        if (v === 'az') return a.dataset.name.localeCompare(b.dataset.name);
        if (v === 'za') return b.dataset.name.localeCompare(a.dataset.name);
        return a.dataset.i - b.dataset.i;
      }).forEach(function (c) { grid.appendChild(c); });
    });
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.kb-chip'); if (!b) return;
      bar.querySelectorAll('.kb-chip').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      var f = b.dataset.fam;
      cards.forEach(function (c) { c.hidden = !!f && (fams[c.dataset.name] || []).indexOf(f) === -1; });
    });
    drawer.querySelectorAll('[data-kb-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        grid.dataset.view = b.dataset.kbView;
        drawer.querySelectorAll('[data-kb-view]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      });
    });

    addBtn.addEventListener('click', function () {
      if (picks.length < MAX) return;
      addBtn.disabled = true;
      var counts = {};
      picks.forEach(function (p) { counts[p.id] = (counts[p.id] || 0) + 1; });
      var items = [{ id: +root.dataset.kit, quantity: 1, properties: { Shades: picks.map(function (p) { return p.name; }).join(', ') } }];
      Object.keys(counts).forEach(function (id) { items.push({ id: +id, quantity: counts[id] }); });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { close(); picks = []; render(); return openCart(); })
        .catch(function () { addBtn.disabled = false; alert('Could not add the kit. Please try again.'); });
    });

    function openCart() {
      var cd = document.querySelector('cart-drawer');
      if (!cd) { location.href = '/cart'; return; }
      return Promise.all([
        fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }),
        fetch('/?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).catch(function () { return ''; })
      ]).then(function (res) {
        var doc = new DOMParser().parseFromString(res[0], 'text/html');
        var fresh = doc.querySelector('cart-drawer .drawer__inner'), cur = cd.querySelector('.drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        cd.classList.remove('is-empty');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res[1]) { var b = new DOMParser().parseFromString(res[1], 'text/html').querySelector('.shopify-section'); if (b) bubble.innerHTML = b.innerHTML; }
        if (typeof cd.open === 'function') cd.open(); else { cd.classList.add('active', 'animate'); document.body.classList.add('overflow-hidden'); }
      }).catch(function () { location.href = '/cart'; });
    }

    // barra fija: aparece cuando el CTA principal sale de pantalla
    var mainCta = root.querySelector('.kb-cta');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.hidden = !off;
      }).observe(mainCta);
    }
    render();
  }
  function boot() { document.querySelectorAll('.kb[data-kit]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
